export const FILTERS_RESET = 'FILTERS_RESET';
export const FILTERS_UPDATE = 'FILTERS_UPDATE';

export const resetFilters = () => {
    return {
        type: FILTERS_RESET,
    };
};

export const updateFilters = settings => {
    return {
        type: FILTERS_UPDATE,
        payload: settings,
    };
};
